/**
 * Ressources humaines (WALLIYO-0131), en français. A faithful translation of hr.en.ts,
 * which is the source text.
 */
export const hrFr = {
  "hr.tabs.aria": "Ressources humaines",
  "hr.tab.directory": "Annuaire",
  "hr.tab.recruiting": "Recrutement",
  "hr.tab.employees": "Employés",
  "hr.tab.learning": "Formation",
  "hr.subTabs.aria": "Employés",
  "hr.sub.records": "Dossiers",
  "hr.sub.joining": "Arrivées",
  "hr.sub.timeOff": "Congés de tous",
  "hr.sub.performance": "Performance",
  "hr.sub.payroll": "Paie",
  "hr.sub.reviews": "Revues",
  "hr.sub.leaving": "Départs",
  "hr.locked": "Cet onglet est réservé aux ressources humaines.",
  "hr.notBuilt": "Pas encore construit.",
  "hr.notBuiltHelp": "Cet onglet est conçu et attend son point d'accès. Rien n'est perdu à le laisser.",
  "directory.title": "Annuaire",
  "directory.sub": "Chacun peut chercher n'importe qui.",
  "directory.search": "Chercher quelqu'un",
  "directory.searchHelp": "Un nom, ou le numéro de son badge.",
  "directory.searchPlaceholder": "Nom ou UUID",
  "directory.go": "Chercher",
  "directory.clear": "Voir tout le monde",
  "directory.loading": "Lecture de l'annuaire…",
  "directory.failed": "L'annuaire n'a pas pu être lu.",
  "directory.retry": "Réessayer",
  "directory.none": "Personne ici ne correspond à « {query} ».",
  "directory.empty": "Personne n'est encore répertorié.",
  "directory.count": "{shown} sur {total}",
  "directory.more": "Plus de résultats que ceux affichés. Affinez la recherche.",
  "directory.colName": "Nom",
  "directory.colRoles": "Rôle",
  "directory.colTeams": "Équipes",
  "directory.colManager": "Responsable",
  "directory.open": "Ouvrir",
  "directory.noRole": "Pas encore de rôle",
  "directory.noTeam": "Pas encore d'équipe",
  "directory.noManager": "Pas de responsable",
  "directory.leads": "la dirige",
  "directory.invited": "Invité",
  "directory.back": "Retour à l'annuaire",
  "directory.identity": "Qui c'est",
  "directory.uuid": "UUID",
  "directory.uuidHelp": "Le numéro de son badge. Il ne change jamais.",
  "directory.email": "E-mail",
  "directory.managerOn": "{name}, {team}",
  "directory.teammates": "Toute l'équipe",
  "directory.whereTheySit": "Où cette personne se situe",
  "directory.emailThem": "Envoyer un e-mail",
  "directory.teammatesNone": "Il ou elle est seul(e) dans ses équipes.",
  "directory.personFailed": "Cette personne n'a pas pu être lue.",
  "directory.viewOnly": "L'annuaire montre la structure seulement. Ce que quelqu'un peut faire est dans Employés.",
  "hr.loading": "Lecture…",
  "hr.failed": "Impossible de lire cela.",
  "hr.retry": "Réessayer",
  "joining.invite": "Inviter quelqu'un",
  "joining.invited.title": "Invitations en cours",
  "joining.invited.help": "Ils ont déjà un UUID et ne peuvent pas se connecter tant qu'ils n'ont pas de mot de passe.",
  "joining.invited.none": "Personne n'attend d'arriver.",
  "joining.arrived.title": "Arrivés récemment",
  "joining.arrived.help": "Tous ceux qui ont rejoint ces 30 derniers jours.",
  "joining.arrived.none": "Personne n'a rejoint ces 30 derniers jours.",
  "joining.col.name": "Nom",
  "joining.col.roles": "Rôle",
  "joining.col.sent": "Invité le",
  "joining.col.waiting": "En attente",
  "joining.col.joined": "Arrivé le",
  "joining.today": "Aujourd'hui",
  "joining.waiting": "{days} jours",
  "joining.stale": "À relancer",

  // ── Leaving ──
  "leaving.who": "Qui part",
  "leaving.whoHelp": "Tous ceux qui sont encore là, et ceux qui sont déjà partis.",
  "leaving.pick": "Choisir quelqu'un",
  "leaving.alreadyLeft": "déjà parti",
  "leaving.nobody": "Choisissez quelqu'un pour voir ce que son départ laisserait derrière.",
  "leaving.gone": "{name} est déjà parti. Voici ce qui est resté en suspens.",
  "leaving.noReason": "Aucun motif donné",
  "leaving.teams.title": "Équipes qu'il ou elle dirige",
  "leaving.teams.help":
    "Sans personne à sa tête, une équipe n'a plus personne pour approuver les congés, faire les revues ni attester des accès — c'est le même fait.",
  "leaving.teams.none": "Il ou elle ne dirige aucune équipe.",
  "leaving.teams.col.team": "Équipe",
  "leaving.teams.col.others": "Autres personnes",
  "leaving.teams.col.after": "Après son départ",
  "leaving.team.others": "{count} autres",
  "leaving.team.noLead": "Plus personne ne la dirigerait",
  "leaving.team.covered": "Quelqu'un d'autre la dirige",
  "leaving.team.handOver": "Transmettre",
  "leaving.grants.title": "Accordé à son nom",
  "leaving.grants.help":
    "Retirer un rôle n'y touche jamais. Un accès sans date de fin, c'est ainsi que quelqu'un qui est parti garde une permission.",
  "leaving.grants.none": "Rien ne lui a été accordé à son nom.",
  "leaving.grants.col.what": "Quoi",
  "leaving.grants.col.why": "Pourquoi",
  "leaving.grants.col.ends": "Fin",
  "leaving.grant.forever": "Sans fin",
  "leaving.grant.until": "Jusqu'au",
  "leaving.grants.revoke": "Retirer ces accès",
  "leaving.last.title": "La dernière étape",
  "leaving.last.help":
    "La désactivation coupe ses {sessions} sessions ouvertes et l'empêche de se connecter. Rien de ce qu'il ou elle a fait n'est effacé — l'audit le nomme pour toujours — et il ou elle reste listé dans ses équipes, pour que personne ne manque discrètement quelqu'un.",
  "leaving.last.deactivate": "Désactiver",
  "leaving.last.seeThem": "Le voir dans l'annuaire",

  // ── Records ──
  "records.find": "Chercher",
  "records.findPlaceholder": "Nom ou e-mail",
  "records.team": "Équipe",
  "records.role": "Rôle",
  "records.any": "Tous",
  "records.dueReview": "{count} accès à revoir",
  "records.accessDueReview": "accès à revoir",
  "records.none": "Personne ne correspond.",
  "records.neverSeen": "Jamais connecté",
  "records.col.person": "Personne",
  "records.col.role": "Rôle",
  "records.col.teams": "Équipes",
  "records.col.joined": "Arrivé le",
  "records.col.lastSeen": "Vu pour la dernière fois",

  // ── Time off ──
  "timeOff.ask": "Demander un congé",
  "timeOff.approve": "Approuver",
  "timeOff.refuse": "Refuser",
  "timeOff.days": "{days} jours",
  "timeOff.decidedBy": "Décidé par {name}",
  "timeOff.col.who": "Qui",
  "timeOff.col.kind": "Type",
  "timeOff.col.when": "Quand",
  "timeOff.col.days": "Jours",
  "timeOff.col.status": "Statut",
  "timeOff.kind.annual": "Congé annuel",
  "timeOff.kind.sick": "Congé maladie",
  "timeOff.kind.unpaid": "Sans solde",
  "timeOff.kind.parental": "Congé parental",
  "timeOff.kind.other": "Autre",
  "timeOff.status.pending": "En attente",
  "timeOff.status.approved": "Approuvé",
  "timeOff.status.refused": "Refusé",
  "timeOff.status.withdrawn": "Retiré",
  "timeOff.balance.title": "Votre solde",
  "timeOff.balance.none":
    "Personne n'a encore fixé vos droits. Les ressources humaines le font sur votre dossier d'emploi.",
  "timeOff.balance.allowance": "Droits",
  "timeOff.balance.taken": "Pris",
  "timeOff.balance.pending": "Demandé",
  "timeOff.balance.pendingHelp": "Pas pris, mais pas libre non plus.",
  "timeOff.balance.left": "Restant",
  "timeOff.toDecide.title": "En attente de vous",
  "timeOff.toDecide.help":
    "Vous dirigez leur équipe, c'est donc à vous de décider. Être aux RH n'est pas la même chose.",
  "timeOff.mine.title": "Vos demandes",
  "timeOff.mine.none": "Vous n'avez demandé aucun congé.",
  "timeOff.away.title": "Absents aujourd'hui",
  "timeOff.away.none": "Personne n'est absent aujourd'hui.",
  "timeOff.everybody.title": "Tout le monde",
  "timeOff.everybody.help":
    "Vous les voyez parce que vous êtes aux RH. La décision revient au responsable de leur équipe.",
  "timeOff.form.title": "Demander un congé",
  "timeOff.form.kind": "Type",
  "timeOff.form.from": "Premier jour",
  "timeOff.form.to": "Dernier jour",
  "timeOff.form.days": "Jours",
  "timeOff.form.daysHelp": "Combien de jours ouvrés cela couvre.",
  "timeOff.form.reason": "Motif",
  "timeOff.form.submit": "Envoyer la demande",
  "timeOff.decide.title": "Décider cette demande",
  "timeOff.decide.approveNote": "Dites pourquoi vous approuvez",
  "timeOff.decide.refuseNote": "Dites pourquoi vous refusez",
  "timeOff.decide.submit": "Enregistrer la décision",
  "timeOff.done": "{days} jours demandés. C'est le responsable de votre équipe qui décide.",
  "timeOff.approvedDone": "Le congé de {name} est approuvé.",
  "timeOff.refusedDone": "La demande de {name} est refusée.",

  // ── Reviews ──
  "reviews.grants.title": "À regarder maintenant",
  "reviews.grants.help":
    "Un accès avec une date de fin se retire tout seul. Voici ceux qui ne le font pas, et ceux détenus par quelqu'un qui n'est plus là.",
  "reviews.grants.none": "Rien n'est détenu à titre nominatif sans date de fin.",
  "reviews.leads.title": "Responsables qui doivent revoir leurs équipes",
  "reviews.leads.help":
    "Le responsable de leur équipe, nous le connaissons déjà — personne n'a besoin qu'on lui dise qui revoit qui.",
  "reviews.leads.none": "Personne dans les équipes ne détient d'accès nominatif.",
  "reviews.col.who": "Qui",
  "reviews.col.what": "Quoi",
  "reviews.col.why": "Pourquoi",
  "reviews.col.concern": "Problème",
  "reviews.col.lead": "Responsable",
  "reviews.col.team": "Équipe",
  "reviews.col.people": "Personnes",
  "reviews.col.neverEnding": "Sans fin",
  "reviews.concern.holderLeft": "A quitté l'entreprise",
  "reviews.concern.neverEnds": "Sans fin",
  "reviews.concern.neverUsed": "Jamais utilisé",
  "reviews.changedAt": "Modifié le {when}",
  "reviews.open": "Ouvrir ses permissions",

  // ── Payroll ──
  "payroll.month": "Mois",
  "payroll.open": "Ouvrir un mois",
  "payroll.close": "Clôturer le mois",
  "payroll.notOpen": "Ce mois n'a pas encore été ouvert.",
  "payroll.closedOn": "Clôturé le {when} par {name}",
  "payroll.hold": "Suspendre",
  "payroll.release": "Libérer",
  "payroll.lines.title": "Ce que chacun perçoit",
  "payroll.lines.help":
    "Établi d'après les dossiers d'emploi tels qu'ils étaient à l'ouverture du mois. Une augmentation ultérieure ne change rien ici.",
  "payroll.col.person": "Personne",
  "payroll.col.gross": "Brut",
  "payroll.col.contributions": "Cotisations",
  "payroll.col.net": "Net",
  "payroll.col.status": "Statut",
  "payroll.status.ready": "Prêt",
  "payroll.status.held": "Suspendu",
  "payroll.status.paid": "Payé",
  "payroll.total.people": "Personnes",
  "payroll.total.gross": "Brut",
  "payroll.total.contributions": "Cotisations",
  "payroll.total.net": "Net",
  "payroll.missing.title": "Personne ne sait ce que ces gens gagnent",
  "payroll.missing.help":
    "Leur dossier d'emploi n'indique aucun brut, la paie ne peut donc pas les payer. Renseignez-le avant le prochain mois.",
  "payroll.openForm.title": "Ouvrir un mois",
  "payroll.openForm.month": "Mois",
  "payroll.openForm.help":
    "Chaque dossier d'emploi avec un brut reçoit une ligne. Les cotisations partent de zéro : ce qui est retenu dépend du lieu, et cet écran n'a pas à le deviner.",
  "payroll.openForm.submit": "Ouvrir",
  "payroll.holdForm.title": "Modifier cette ligne",
  "payroll.holdForm.hold": "Suspendre",
  "payroll.holdForm.release": "Libérer",
  "payroll.closeForm.title": "Clôturer le mois",
  "payroll.closeForm.help":
    "Chaque ligne prête passe en payée. Une ligne suspendue le reste, c'est à cela qu'elle sert.",
  "payroll.closeForm.submit": "Clôturer",
  "payroll.opened": "{month} est ouvert, avec {count} lignes.",
  "payroll.held": "La ligne de {name} est suspendue.",
  "payroll.released": "La ligne de {name} sera payée.",
  "payroll.closed": "Le mois est clôturé.",

  // ── Performance ──
  "performance.cycle": "Cycle",
  "performance.openCycle": "Ouvrir un cycle",
  "performance.noCycle": "Aucun cycle n'a encore été ouvert.",
  "performance.runs": "Du {from} au {to}",
  "performance.write": "Rédiger",
  "performance.keepWriting": "Continuer",
  "performance.col.who": "Qui",
  "performance.col.reviewer": "Évaluateur",
  "performance.col.status": "Statut",
  "performance.col.outcome": "Comment ça s'est passé",
  "performance.status.notStarted": "Pas commencé",
  "performance.status.inProgress": "En cours de rédaction",
  "performance.status.submitted": "Envoyé",
  "performance.status.signedOff": "Validé",
  "performance.gap.noTeam": "Dans aucune équipe",
  "performance.gap.noLead": "L'équipe n'a pas de responsable",
  "performance.gap.leadsOwn": "Dirige sa propre équipe",
  "performance.toWrite.title": "En attente de vous",
  "performance.toWrite.help": "Vous dirigez leur équipe, c'est donc à vous de la rédiger.",
  "performance.mine.title": "Votre évaluation",
  "performance.mine.none": "Vous n'avez pas d'évaluation ce cycle.",
  "performance.everybody.title": "Tout le monde",
  "performance.everybody.help": "Vous les voyez parce que vous êtes aux RH. La rédaction revient à l'évaluateur.",
  "performance.everybody.gaps":
    "{count} d'entre elles n'ont personne pour les rédiger. Cela concerne l'organisation, pas ce cycle.",
  "performance.form.title": "Ouvrir un cycle",
  "performance.form.name": "Nom",
  "performance.form.opens": "Premier jour",
  "performance.form.closes": "Dernier jour",
  "performance.form.submit": "Ouvrir",
  "performance.writeForm.title": "Rédiger l'évaluation",
  "performance.writeForm.outcome": "Comment ça s'est passé",
  "performance.writeForm.outcomeHelp": "Un mot que vous choisissez, pas une note sur cinq.",
  "performance.writeForm.note": "Ce qui s'est passé",
  "performance.writeForm.save": "Enregistrer pour plus tard",
  "performance.writeForm.send": "Envoyer",
  "performance.opened": "{name} est ouvert, avec {count} évaluations.",
  "performance.saved": "Enregistré. Personne ne le voit avant l'envoi.",
  "performance.sent": "Envoyé. {name} peut le voir.",

  // ── Recruiting and Learning ──
  "recruiting.openJob": "Ouvrir un poste",
  "recruiting.editJob": "Modifier",
  "recruiting.addCandidate": "Ajouter quelqu'un",
  "recruiting.move": "Faire avancer",
  "recruiting.none": "Aucun poste n'a encore été ouvert.",
  "recruiting.noTeam": "Sans équipe",
  "recruiting.noCandidates": "Personne n'a encore postulé.",
  "recruiting.liveCandidates": "{count} en lice",
  "recruiting.col.candidate": "Candidat",
  "recruiting.col.reach": "Comment le joindre",
  "recruiting.col.stage": "Étape",
  "recruiting.col.applied": "Candidature",
  "recruiting.stage.applied": "Candidature",
  "recruiting.stage.screening": "Présélection",
  "recruiting.stage.interview": "Entretien",
  "recruiting.stage.offer": "Offre envoyée",
  "recruiting.stage.hired": "Recruté",
  "recruiting.stage.declined": "Refusé",
  "recruiting.stage.withdrawn": "Retiré",
  "recruiting.status.open": "Ouvert",
  "recruiting.status.onHold": "En pause",
  "recruiting.status.filled": "Pourvu",
  "recruiting.status.closed": "Fermé",
  "recruiting.jobForm.title": "Ouvrir un poste",
  "recruiting.jobForm.name": "Intitulé",
  "recruiting.jobForm.team": "Équipe",
  "recruiting.jobForm.noTeam": "Pas encore d'équipe",
  "recruiting.jobForm.description": "En quoi consiste le poste",
  "recruiting.jobForm.status": "Statut",
  "recruiting.jobForm.submit": "Ouvrir",
  "recruiting.candidateForm.title": "Ajouter quelqu'un",
  "recruiting.candidateForm.name": "Nom",
  "recruiting.candidateForm.phone": "Téléphone",
  "recruiting.candidateForm.email": "E-mail",
  "recruiting.candidateForm.note": "Ce qu'il faut savoir",
  "recruiting.candidateForm.submit": "Ajouter",
  "recruiting.moveForm.title": "Faire avancer",
  "recruiting.moveForm.stage": "Étape",
  "recruiting.moveForm.hired":
    "Marquer quelqu'un comme recruté enregistre qu'il l'a été. L'inviter se fait dans Arrivées, où cela existe déjà.",
  "recruiting.moveForm.submit": "Faire avancer",
  "recruiting.jobOpened": "{title} est ouvert.",
  "recruiting.jobEdited": "{title} est mis à jour.",
  "recruiting.candidateAdded": "{name} est sur la liste.",
  "recruiting.candidateMoved": "{name} est maintenant à l'étape {stage}.",
  "learning.addCourse": "Ajouter une formation",
  "learning.enrol": "S'inscrire",
  "learning.continue": "Continuer",
  "learning.finish": "Terminer",
  "learning.alreadyEnrolled": "Inscrit",
  "learning.requiredBy": "Requise par {permission} — à terminer avant l'octroi, pas après.",
  "learning.requiredOfAll": "Obligatoire pour tous",
  "learning.anybody": "Ouverte à tous",
  "learning.minutes": "{minutes} min",
  "learning.enrolled": "{count} inscrits",
  "learning.hrOnly": "Réservé aux RH",
  "learning.mine.title": "Obligatoire pour vous",
  "learning.mine.help": "Une formation liée à une permission doit être terminée avant que la permission soit accordée.",
  "learning.mine.none": "Rien n'est obligatoire pour vous en ce moment.",
  "learning.catalogue.title": "Catalogue",
  "learning.catalogue.help":
    "Ouvert à tous. S'inscrire ne demande l'accord de personne — c'est l'accès derrière la formation qui le demande.",
  "learning.byTeam.title": "Dans toute l'entreprise",
  "learning.byTeam.help":
    "Qui doit encore suivre les formations obligatoires. C'est au responsable de l'équipe de relancer.",
  "learning.col.course": "Formation",
  "learning.col.status": "Statut",
  "learning.col.progress": "Progression",
  "learning.col.team": "Équipe",
  "learning.col.people": "Personnes",
  "learning.col.done": "Terminé",
  "learning.status.enrolled": "Inscrit",
  "learning.status.inProgress": "En cours",
  "learning.status.done": "Terminée",
  "learning.courseForm.title": "Ajouter une formation",
  "learning.courseForm.name": "Titre",
  "learning.courseForm.audience": "Pour qui",
  "learning.courseForm.minutes": "Durée, en minutes",
  "learning.courseForm.required": "Requise par une permission",
  "learning.courseForm.requiredHelp":
    "L'identifiant du réglage de la permission dont cette formation est une condition.",
  "learning.courseForm.everybody": "Obligatoire pour tous",
  "learning.courseForm.submit": "Ajouter",
  "learning.courseAdded": "{title} est au catalogue.",
  "learning.enrolledDone": "Inscrit à {title}.",
  "learning.finished": "{title} est terminée.",

  // ── Alerts and refusals ──
  "alert.dismiss": "Fermer",
  "error.reason.permission_not_held":
    "Votre rôle ouvre cet écran, mais pas cette action. Demandez à quelqu'un qui peut l'accorder.",
  "error.reason.not_found": "Cela n'existe plus. Rechargez et réessayez.",
  "error.reason.no_reason": "Dites pourquoi, en quelques mots.",
  "error.reason.name_taken": "Ce nom est déjà pris.",
  "error.reason.team_closed": "C'est fermé. Rouvrez-le avant d'ajouter quelqu'un.",
  "error.reason.staff_deactivated": "Cette personne est partie, elle ne peut pas être ajoutée.",
  "error.reason.lead_must_be_member": "On ne dirige que l'équipe dont on fait partie.",
  "error.reason.duplicate_change": "La même personne apparaît deux fois. Envoyez-la une seule fois.",
  "error.reason.own_request": "Vous ne pouvez pas décider de votre propre congé.",
  "error.reason.not_their_lead":
    "Seul le responsable de leur équipe peut décider. Être aux RH n'est pas la même chose.",
  "error.reason.already_decided": "C'est déjà décidé. Rechargez pour voir la décision.",
  "error.reason.backwards": "Le dernier jour est avant le premier.",
  "error.reason.too_long": "C'est plus long qu'une seule demande ne peut couvrir.",
  "error.reason.month_open": "Ce mois est déjà ouvert.",
  "error.reason.already_paid": "Cette ligne a été payée. Un mois clôturé, c'est ce qui a été payé.",
  "error.reason.already_closed": "Ce mois est déjà clôturé.",
  "error.reason.nobody_payable": "Aucun brut n'est enregistré sur les dossiers d'emploi.",
  "error.reason.invalid_month": "Indiquez le mois au format AAAA-MM.",
  "error.reason.own_review": "Vous ne pouvez pas rédiger votre propre évaluation.",
  "error.reason.not_the_reviewer": "Quelqu'un d'autre a été désigné pour la rédiger.",
  "error.reason.signed_off": "Cette évaluation a été validée.",
  "error.reason.no_outcome": "Dites comment ça s'est passé avant d'envoyer.",
  "error.reason.job_closed": "Ce poste est fermé. Rouvrez-le avant d'ajouter quelqu'un.",
  "error.reason.candidate_out": "Cette personne n'est plus en lice. Ajoutez-la de nouveau si elle revient.",
  "error.reason.title_taken": "Ce titre est déjà pris.",
  "error.reason.course_retired": "Cette formation n'est plus proposée.",
  "error.reason.invalid_progress": "La progression est un pourcentage entier, de 0 à 100.",

  // ── Roles: what a role covers ──
  "roles.covers.everything": "Tout",
  "roles.covers.features": "{count} fonctionnalités",
  "roles.covers.permissions": "{count} permissions",
  "roles.covers.critical": "{count} critiques",
  "roles.covers.high": "{count} élevées",
  "roles.covers.seeAll": "Voir les {count}",
  "roles.covers.permissionsHeading": "Permissions",

  // ── Roles, redesigned ──
  "roles.band.critical": "rôles peuvent décider de ce que chacun peut faire",
  "roles.band.people": "personnes en détiennent un",
  "roles.band.total": "rôles au total",
  "roles.band.unheld": "que personne ne détient",
  "roles.reach.critical": "Critique",
  "roles.reach.high": "Élevé",
  "roles.reach.low": "Faible",
  "roles.rail.people": "{count} personnes",
  "roles.rail.unheld": "personne ne le détient",
  "roles.noDescription": "Sans description",
  "roles.figure.people": "Personnes",
  "roles.figure.features": "Fonctionnalités",
  "roles.figure.permissions": "Permissions",
  "roles.figure.critical": "Critiques",
  "roles.block.holders": "Qui le détient",
  "roles.block.holdersHelp": "Donner ce rôle à quelqu'un lui donne tout ce qui suit.",
  "roles.block.holdersNone": "Personne ne détient ce rôle.",
  "roles.block.give": "Le donner à quelqu'un",
  "roles.block.take": "Le retirer",
  "roles.block.grants": "Ce qu'il accorde",
  "roles.block.grantsHelp": "Sa portée, par domaine.",
  "roles.block.criticalWarning": "Celui qui détient ce rôle peut décider de ce que tous les autres peuvent faire.",
  "roles.block.change": "Modifier ce qu'il accorde",
  "roles.block.opens": "Ce qu'il ouvre",
  "roles.block.opensHelp":
    "Calculé à partir des fonctionnalités ci-dessus, jamais stocké — le menu interroge la même fonction.",
  "roles.block.opensNone": "Il n'ouvre aucun écran à lui seul.",
  "roles.block.compare": "Comparé à",
  "roles.block.compareWith": "Comparer avec",
  "roles.compare.only": "{count} uniquement ici",
  "roles.compare.theirs": "{count} uniquement là",
  "roles.compare.shared": "{count} en commun",
  "roles.give.title": "Donner ce rôle à quelqu'un",
  "roles.give.who": "Qui",
  "roles.give.submit": "Le lui donner",
  "roles.give.done": "{name} détient maintenant {role}.",
  "roles.take.title": "Retirer ce rôle",
  "roles.take.body": "Cette personne garde tous ses autres rôles.",
  "roles.take.submit": "Le retirer",
  "roles.take.done": "{name} ne détient plus {role}.",
  "roles.holdersUnknown": "Lecture impossible",
  "roles.compare.same": "Ils accordent exactement les mêmes fonctionnalités.",
  "roles.notice.critical":
    "{roles} d'entre eux peuvent décider de ce que chacun peut faire — {people} personnes en détiennent un.",
  "roles.notice.criticalOnly": "{roles} d'entre eux peuvent décider de ce que chacun peut faire.",
  "roles.notice.unheld": "{count} que personne ne détient.",

  // ── Actions, by person ──
  "actions.find": "Chercher quelqu'un",
  "actions.matches": "Qui vouliez-vous dire ?",
  "actions.findPlaceholder": "Nom ou UUID",
  "actions.nobody": "Cherchez quelqu'un pour voir ce qu'il peut faire.",
  "actions.noRoles": "Sans rôle",
  "actions.col.on": "Activé",
  "actions.col.source": "Source",
  "actions.col.reason": "Motif",
  "actions.mustAsk": "doit demander au-delà de {limit}",
  "actions.clear": "Effacer",
  "actions.until": "jusqu'au {when}",
  "actions.onlyOverrides":
    "Seule une dérogation est posée sur cette personne, c'est donc la seule que cet écran peut retirer. Le reste vient d'un rôle ou de la façon dont l'action est livrée — modifiez-les là où ils vivent.",
  "actions.blocked.permission": "Elle a la fonctionnalité, pas la permission qu'exige cette action.",
  "actions.locked.noFeature": "Ouverte à tous : il n'y a aucun interrupteur derrière.",
  "actions.view.catalogue": "Le catalogue",
  "actions.view.person": "Par personne",
  "actions.notWiredYet":
    "L'activation n'est pas encore branchée. Utilisez Fonctionnalités et Permissions pour l'instant.",
  "actions.view.role": "Par rôle",
  "actions.pickRole": "Rôle",

  // ── Switching an action ──
  "actions.switch.onTitle": "Activer",
  "actions.switch.offTitle": "Désactiver",
  "actions.switch.clearTitle": "Effacer",
  "actions.switch.submit": "Activer",
  "actions.switch.writes": "Cela écrit la fonctionnalité sous-jacente : {feature}.",
  "actions.switch.alsoMoves":
    "Cette fonctionnalité ouvre aussi {count} autres actions, qui bougent avec elle : {actions}.",
  "actions.switch.permissionToo":
    "Il faudra encore la permission qui garde cette action. Accordez-la dans Permissions.",
  "actions.switch.switchedOn": "{action} est activée pour {who}.",
  "actions.switch.switchedOff": "{action} est désactivée pour {who}.",
  "actions.switch.cleared": "{action} revient à ce qui est hérité.",
  "actions.pending": "pas encore enregistré",
  "actions.saved": "{count} interrupteurs enregistrés.",
} as const;
